import { useInboxModuleType } from "@/composables/v2.1/useInboxModuleType";
import ChannelInterface from "@/interfaces/channel.interface";
import axios from "@/libs/axios";
import { InboxModuleType } from "@/types/inboxModule.type";
import { useQuery } from "@tanstack/vue-query";
import { reactive, toRefs } from "@vue/composition-api";
import { AxiosRequestConfig } from "axios";

interface RootState {
    channels: ChannelInterface[];
    loading: boolean;
    error: boolean;
    isFetching: boolean;
}

const state: RootState = reactive({
    channels: [],
    loading: false,
    error: false,
    isFetching: false,
});

export default function useChannels() {
    const { inboxModuleType, isInboxModule } = useInboxModuleType();

    const fetchChannels = (queryParams: AxiosRequestConfig): void => {
        if (isInboxModule()) {
            queryParams.params.s = {
                $and: [
                    queryParams?.params.s,
                    {
                        platform:
                            inboxModuleType.value === InboxModuleType.EMAIL
                                ? { $eq: InboxModuleType.EMAIL }
                                : { $ne: InboxModuleType.EMAIL },
                    },
                ],
            };
        }

        const { data, isLoading, isFetching, isError } = useQuery(
            ["channels"],
            () => axios.get("/channels", queryParams),
            {
                select: (response: { data: ChannelInterface[] }) =>
                    response.data.map((channel) => ({ ...channel, legacy: true })),
                refetchOnWindowFocus: false,
                refetchOnMount: true,
                //staleTime: 5000, // With email, we always want realtime data. Idk vue-query mutations or refetch, so commented this for now.
                placeholderData: { data: [{ legacy: true }] } as any,
            }
        );

        // @ts-ignore
        state.loading = isLoading;
        // @ts-ignore
        state.channels = data;
        // @ts-ignore
        state.error = isError;
        // @ts-ignore
        state.isFetching = isFetching;
    };

    return {
        fetchChannels,
        ...toRefs(state),
    };
}
